<template>
  <header class="relative z-10 m-6 mb-20 sm:px-4">
    <div class="flex items-center justify-between">
      <div>
        <a href="/"><img src="@/assets/logo.png" width="220" alt="Logo" /></a>
      </div>

      <!-- Navigation on desktop -->
      <nav class="hidden text-small font-semibold lg:block">
        <ul class="flex items-center gap-12">
          <li>
            <a href="#help" class="transition-all hover:text-primary"
              >S čím pomáhám</a
            >
          </li>
          <li>
            <a href="#reviews" class="transition-all hover:text-primary"
              >Reference</a
            >
          </li>
          <li>
            <a href="#price" class="transition-all hover:text-primary">Ceník</a>
          </li>
        </ul>
      </nav>
      <div class="hidden items-center gap-10 font-semibold lg:flex">
        <div
          class="inline-flex items-center text-secondary transition-all hover:text-[#4eb999]"
        >
          <i class="pi pi-phone mr-2"></i
          ><a href="tel:+420724219238">724 219 238</a>
        </div>
        <a href="#contact"
          ><button
            class="rounded-3xl rounded-br-none bg-primary px-6 py-3 font-bold text-white transition-all hover:bg-[#ffa616e4]"
          >
            Kontakt
          </button></a
        >
      </div>

      <!-- Menu Icon -->
      <div class="flex items-center px-6 py-3 lg:hidden">
        <button @click="isMenuOpen = !isMenuOpen" class="h-6 w-6 text-2xl">
          <i class="pi pi-bars"></i>
        </button>
      </div>
    </div>

    <!-- Navigation on mobile -->
    <transition name="menu">
      <div
        v-if="isMenuOpen"
        class="fixed right-0 top-0 z-20 flex h-full w-3/5 flex-col items-start bg-white p-8 font-semibold shadow-lg"
      >
        <button @click="isMenuOpen = false" class="self-end text-2xl">
          <i class="pi pi-times"></i>
        </button>
        <ul class="mt-10 flex flex-col gap-10">
          <li>
            <a
              href="#help"
              class="transition-all hover:text-primary"
              @click="isMenuOpen = false"
              >S čím pomáhám</a
            >
          </li>
          <li>
            <a
              href="#reviews"
              class="transition-all hover:text-primary"
              @click="isMenuOpen = false"
              >Reference</a
            >
          </li>
          <li>
            <a
              href="#price"
              class="transition-all hover:text-primary"
              @click="isMenuOpen = false"
              >Ceník</a
            >
          </li>
        </ul>
        <div class="mt-10 flex flex-col gap-8">
          <a
            href="tel:+420724219238"
            class="mb-2 block text-secondary transition-all hover:text-[#4eb999]"
          >
            <span class="pi pi-phone mr-2"></span>724 219 238
          </a>
          <a href="#contact"
            ><button
              class="rounded-3xl rounded-bl-none bg-primary px-6 py-3 text-white transition-all hover:bg-[#ffa616e4]"
              @click="isMenuOpen = false"
            >
              Kontakt
            </button></a
          >
        </div>
      </div>
    </transition>
  </header>

  <section class="min-h-[600px] overflow-x-hidden" id="hero">
    <img
      src="@/assets/hero.png"
      class="background-photo absolute left-0 top-0 -z-10 h-[770px] w-full bg-cover object-cover"
      alt="Hero Image"
    />

    <div class="flex items-center justify-center" data-aos="fade-right">
      <div
        class="box-hero relative mx-10 mr-[10rem] h-[340px] w-4/5 max-w-6xl rounded-[90px] rounded-bl-none bg-lightPrimary px-10 py-8 sm:px-20"
      >
        <a
            href="#about"
            class="block text-right text-sm font-semibold text-primary transition-all hover:text-[#ffa616e4] sm:text-[16px] animate-bouncePulse"
        >
          Pokračovat na sekci o mně >>
        </a>
        <h1
          class="text-hero mt-16 max-w-[450px] text-2xl font-semibold leading-[39px] sm:text-[26px] xl:max-w-2xl"
        >
          <span class="uppercase text-primary"
            >Každý si zaslouží být vyslyšen</span
          ><br />
          Sdílejte své příběhy v bezpečném a vstřícném prostředí.
        </h1>

        <img
          src="@/assets/main-image.png"
          alt="Main Image"
          class="photo-hero absolute -right-[100px] top-[80px] mt-2 bg-cover object-contain lg:block xl:max-w-full"
          data-aos="fade-left"
          data-aos-delay="500"
        />
      </div>
    </div>
  </section>
</template>

<script setup>
import { ref } from "vue";

const isMenuOpen = ref(false);
</script>

<style scoped>
.menu-enter-active,
.menu-leave-active {
  transition: transform 0.3s ease;
}

.menu-enter-from {
  transform: translateX(100%);
}

.menu-enter-to {
  transform: translateX(0);
}

.menu-leave-from {
  transform: translateX(0);
}

.menu-leave-to {
  transform: translateX(100%);
}

@media screen and (max-width: 1120px) {
  .photo-hero {
    max-width: 22rem;
  }
}

@media screen and (max-width: 990px) {
  .photo-hero {
    max-width: 18rem;
  }
}

@media screen and (max-width: 940px) {
  .text-hero {
    max-width: 350px;
  }

  .background-photo {
    height: 800px;
  }
}

@media screen and (max-width: 810px) {
  .box-hero {
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
    justify-content: center;
    align-items: center;
    margin-inline: 1rem;
    gap: 1.5rem;
    border-radius: 90px;
    margin-bottom: 2rem;
  }

  .background-photo {
    height: 900px;
  }

  header {
    margin-bottom: 2rem;
  }

  h1 {
    margin-top: 0;
  }

  a {
    align-self: flex-end;
  }

  .text-hero {
    max-width: 100%;
  }

  .photo-hero {
    position: static;
    max-width: 100%;
  }
}
</style>
